import { Component, computed, input } from '@angular/core';

export type modes = 'transformation' | 'ascension' | 'impact' | 'equilibre' | 'introspection';

export function convertStringAsModes(value: string): modes | undefined {
  if (!value) {
    return undefined;
  }

  // Lowercase and remove accents
  value = value.toLocaleLowerCase();
  value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  switch (value) {
    case 'transformation':
      return 'transformation';
    case 'ascension':
      return 'ascension';
    case 'impact':
      return 'impact';
    case 'equilibre':
      return 'equilibre';
    case 'introspection':
      return 'introspection';
    default:
      return undefined;
  }
}

@Component({
  selector: 'smw-modes-chip',
  templateUrl: './modes-chip.component.html',
  styleUrls: ['./modes-chip.component.less'],
})
export class ModesChipComponent {
  constructor() {}

  //**  */
  modes = input.required<string>();
  convertedModes = computed(() => convertStringAsModes(this.modes()));
  modesText = computed(() => {
    const mode = this.convertedModes();
    return String(mode).charAt(0).toUpperCase() + String(mode).slice(1);
  });
}
